import styled from 'styled-components';

const InputSearch = styled.input`
  background: transparent;
  border: none;
  outline: none;
  color: ${(props) => props.theme.colors.textPrimary};
  font-size: 13px;
  width: 100%;
  transition: ${(props) => props.theme.constants.transitionBase};

  &::placeholder {
    color: ${(props) => props.theme.colors.placeholder};
    font-size: 13px;
    font-weight: 400;
    font-style: normal;
  }

  &:-moz-placeholder {
    /* Firefox 18- */
    color: ${(props) => props.theme.colors.placeholder};
    opacity: 1;
  }

  &::-moz-placeholder {
    /* Firefox 19+ */
    color: ${(props) => props.theme.colors.placeholder};
    opacity: 1;
  }

  // hide default clear button of <input type="search" /> in favor of the custom one
  &::-webkit-search-cancel-button {
    display: none;
  }
`;

const Container = styled.label`
  position: relative;
  min-width: 100%;
  width: 100%;
  min-width: 300px;
  display: flex;
  align-items: center;
  gap: 14px;
  background-color: white;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
  border-radius: 9px;
  padding: 9px 12px;
  height: 37px;

  & svg {
    fill: none;
    stroke: #0077ce;
    &.icon-x {
      stroke: ${(props) => props.theme.colors.textPrimary};
    }
  }

  @media ${(props) => props.theme.device.tabletL} {
    min-width: unset;
    width: inherit;
  }
`;

export { Container, InputSearch };
